/**
 * Returns the count of words from the current index until the end of
 * the looping array
 * @param {Number} bodyIndex Current body index in array.
 * @param {Array} bodyElements Array of elements.
 * @returns {Number}
 */
const getWordCountFromCurrentIdxToEnd = ({ bodyIndex, bodyElements }) => {
  let wordCountFromCurrIdxToEnd;

  const subArray = bodyElements.slice(bodyIndex + 1);

  if (subArray) {
    wordCountFromCurrIdxToEnd = subArray.reduce((accumulator, currentValue) => {
      if (currentValue.wordCount) {
        return accumulator + currentValue.wordCount;
      }
      return accumulator;
    }, 0);
  }

  return wordCountFromCurrIdxToEnd;
};

export default getWordCountFromCurrentIdxToEnd;
